import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useDispatch, useSelector } from "react-redux";
import strings from "../i18n/language";
import React, { useState } from "react";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import CustomDateField from "../form/CustomDateField";
import AutoFixNormalIcon from "@mui/icons-material/AutoFixNormal";
import CustomAutocompleteField from "../form/CustomAutocompleteField";
import { toast } from "react-toastify";
import { Typography, IconButton, Button } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  addPatientSubscriptionAction,
  removePatientSubscriptionAction,
} from "../redux/actions/subscription";
import { instance } from "../axios";
import AddIcon from "@mui/icons-material/Add";
import dayjs from "dayjs";
import InfoIcon from "@mui/icons-material/Info";

const SubscriptionPatients = ({ open, setOpen }) => {
  const dispatch = useDispatch();
  const subscription = useSelector((state) => state.subscription.subscription);
  const [patient, setPatient] = useState(null);
  const [date, setDate] = useState(null);
  const user = useSelector((state) => state.user.user);

  if (!subscription?.PatientSubscriptions) return null;
  else
    return (
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {strings.TITLE_PATIENTS_SUBSCRIPTION} #{subscription.id}
        </DialogTitle>
        <DialogContent>
          {subscription?.type === "family" && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <InfoIcon fontSize="small" />
              <Typography variant="body2" component="div">
                {strings.MESSAGE_HEAD_IS_BOLD}
              </Typography>
            </div>
          )}
          {user.type !== "viewer" && (
            <ListItem key="add">
              <CustomAutocompleteField
                loading={true}
                required
                value={patient}
                setValue={setPatient}
                onChange={setPatient}
                margin="normal"
                labelField={"displayName"}
                noOptionsText={strings.MESSAGE_NO_RESULTS}
                label={strings.LABEL_PATIENT}
                launch={async (inputValue, callback) => {
                  const patients = await instance.get(
                    `/patient?query=${encodeURI(inputValue.toLowerCase())}`
                  );
                  callback(patients.data?.data);
                  return patients.data?.data;
                }}
              ></CustomAutocompleteField>
              <IconButton
                onClick={() => {
                  setDate(dayjs(new Date()));
                }}
              >
                <AutoFixNormalIcon></AutoFixNormalIcon>
              </IconButton>
              <CustomDateField
                value={date}
                required
                onChange={setDate}
                margin="normal"
                isValid={!!date}
                label={strings.LABEL_START}
              />
              <IconButton
                onClick={() => {
                  if (!patient || !date)
                    toast.error(strings.ERROR_ENTER_DATE_START);
                  else {
                    dispatch(
                      addPatientSubscriptionAction(subscription.id, {
                        patient_id: patient.id,
                        start: date,
                        end: null,
                      })
                    );
                  }
                }}
              >
                <AddIcon></AddIcon>
              </IconButton>
            </ListItem>
          )}
          <>
            {subscription.PatientSubscriptions.length === 0 && (
              <ListItem style={{ justifyContent: "center" }}>
                <Typography>{strings.MESSAGE_NO_PATIENTS}</Typography>
              </ListItem>
            )}
            {subscription.PatientSubscriptions.map((patientSuscription) => {
              return (
                <ListItem
                  key={
                    patientSuscription.patientId +
                    "-" +
                    patientSuscription.subscriptionId
                  }
                  secondaryAction={
                    user.type !== "viewer" && (
                      <IconButton
                        onClick={() => {
                          dispatch(
                            removePatientSubscriptionAction(
                              patientSuscription.subscriptionId,
                              {
                                patient_id: patientSuscription.patientId,
                              }
                            )
                          );
                        }}
                      >
                        <DeleteIcon></DeleteIcon>
                      </IconButton>
                    )
                  }
                  disablePadding
                >
                  <ListItemText
                    style={{
                      width: "40%",
                    }}
                  >
                    <Typography
                      fontWeight={
                        patientSuscription.Subscription?.type === "family" &&
                        patientSuscription.Patient?.head
                          ? "bold"
                          : "normal"
                      }
                    >
                      {patientSuscription.Patient?.displayName}
                    </Typography>
                  </ListItemText>
                  <ListItemText>
                    {dayjs(patientSuscription.start).format("L")}
                  </ListItemText>
                </ListItem>
              );
            })}
          </>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpen(false);
            }}
          >
            {strings.BUTTON_CLOSE}
          </Button>
        </DialogActions>
      </Dialog>
    );
};

export default SubscriptionPatients;
